import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import Config from '../../commons/config/Config.js';
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import Loading from '../ui/Loading.js'

import moment from 'moment'
import 'moment/min/locales'
import Security from '../../commons/security/Security.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import AtributoDinamicoInstancia from '../atributoDinamico/AtributoDinamicoInstancia.js'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import { atributosDinamicosRequeridosFaltantes, castValoresDinamicos } from '../atributoDinamico/helpers.js'
import * as Constants from '../atributoDinamico/constants.js'
import swal from 'sweetalert'
import { TIPOS_UNIDAD_MEDIDOR as UNIDAD_MEDIDOR }  from '../unidadMedidor/constants.js'
import FormularioTicketTareas from './FormularioTicketTareas.js';
import EricInspeccionPanel from './EricInspeccionPanel.js';
import FormularioAsociadoBloque from './FormularioAsociadoBloque.js';
import $ from 'jquery'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';

import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';

class FormularioAbm extends Component {
  constructor(props) {
    super(props);
    this.ajaxHandler = new AjaxHandler();

    moment.locale("es");

    this.state = {
      redirectTo: null,
      props: this.props,
      formData: {
        valores_dinamicos: [],
        medidor: 0,
        activo: 1,
        tipo_formulario: null,
        movil: null,
        chofer: null,
        persona: null,
        ticket: null,
        observaciones: null,
        imagenes: null,
        documentos: null,
        transportadora: null,
        activo_vinculado: [],
        centro_costos: null,
        tareas: [],
        tareasEnResolucion: false,
        formulario_ticket_historico: null,
        fecha_inicio: null,
        fecha_fin: null
      },
      valores_dinamicos: [],
      latitudForm: null,
      longitudForm: null,
      descripcion: "",
      estados: [
        {
          id: 1,
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.form_status.name_activo",
            defaultMessage: "Activo",
          }),
        },
        {
          id: 0,
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.form_status.name_inactivo",
            defaultMessage: "Inactivo",
          }),
        },
      ],
      movil_atributos_mostrar: [],
      ticket_atributos_mostrar: [],
      moviles_preloaded: null,
      movil: null,
      movil_atributos: [
        {
          id: 'marca',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.marca",
            defaultMessage: "Marca",
          }),
        },
        {
          id: 'modelo',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.modelo",
            defaultMessage: "Modelo",
          }),
        },
        {
          id: 'chasis_nro',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.chasis_nro",
            defaultMessage: "Chasis",
          }),
        },
        {
          id: 'motor_nro',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.motor_nro",
            defaultMessage: "Motor",
          }),
        },
        {
          id: 'color',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.color",
            defaultMessage: "Color",
          }),
        },
        {
          id: 'centro_costos',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.centro_costos",
            defaultMessage: "Centro de Costos",
          }),
        },
        {
          id: 'plan_preventivo',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.plan_preventivo",
            defaultMessage: "Plan Preventivo",
          }),
        },
        {
          id: 'combustible',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.combustible",
            defaultMessage: "Combustible",
          }),
        },
        {
          id: 'proveedor_gps',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.proveedor_gps",
            defaultMessage: "Proveedor GPS",
          }),
        },
        {
          id: 'compania_origen',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.compania_origen",
            defaultMessage: "Compañia de Origen",
          }),
        },
        {
          id: 'titular',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.titular",
            defaultMessage: "Titular",
          }),
        },
        {
          id: 'telepeaje',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.telepeaje",
            defaultMessage: "Peaje",
          }),
        },
        {
          id: 'anio',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.anio",
            defaultMessage: "Año",
          }),
        },
        {
          id: 'estado',
          nombre: this.props.intl.formatMessage({
            id: "formularioAbm.label_movil_atributos.estado",
            defaultMessage: "Estado",
          }),
        },
      ],
      ticket_atributos: [
        {
          id: 'servicio',
          nombre: this.props.intl.formatMessage({
            id: "Servicio",
            defaultMessage: "Servicio",
          }),
        },
        {
          id: 'gerenciador',
          nombre: this.props.intl.formatMessage({
            id: "Gerenciador",
            defaultMessage: "Gerenciador",
          }),
        },
        {
          id: 'centro_costos',
          nombre: this.props.intl.formatMessage({
            id: "Centro_de_costos",
            defaultMessage: "Centro de costos",
          }),
        },
        {
          id: 'mano_de_obra',
          nombre: this.props.intl.formatMessage({
            id: "Presupuesto_mano_de_obra",
            defaultMessage: "Presupuesto mano de obra",
          }),
        },
        {
          id: 'repuestos',
          nombre: this.props.intl.formatMessage({
            id: "Presupuesto_de_repuestos",
            defaultMessage: "Presupuesto de repuestos",
          }),
        },
        {
          id: 'factura',
          nombre: this.props.intl.formatMessage({
            id: "Factura",
            defaultMessage: "Factura",
          }),
        },
      ],
      errors: [],
      loading: false,
      loadingActivosVinculados: false,
      isChoferValid: true,
      tareas: [],
      servicios: [],
      entidad: null,
    };

    this.handleEstadoChange = this.handleEstadoChange.bind(this);
    this.handleChangeAtributoDinamico = this.handleChangeAtributoDinamico.bind(this);
    this.handleInputFormChange = this.handleInputFormChange.bind(this);
    this.handleTipoFormularioChange = this.handleTipoFormularioChange.bind(this);
    this.handleMovilChange = this.handleMovilChange.bind(this);
    this.getBackendMoviles = this.getBackendMoviles.bind(this);
    this.handlePersonaChange = this.handlePersonaChange.bind(this);
    this.handleChoferChange = this.handleChoferChange.bind(this);
    this.getBackendPersonas = this.getBackendPersonas.bind(this);
    this.getBackendTipoForms = this.getBackendTipoForms.bind(this);
    this.getBackendPersonasForBaseOrCc = this.getBackendPersonasForBaseOrCc.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.ticketTareasModal = this.ticketTareasModal.bind(this);
    this.getTareas = this.getTareas.bind(this);
    this.getBackendTickets = this.getBackendTickets.bind(this);
    this.handleTicketChange = this.handleTicketChange.bind(this);
    this.getBackendTransportadora = this.getBackendTransportadora.bind(this);
    this.handleTransportadoraChange = this.handleTransportadoraChange.bind(this);
    this.handleActivoVinculadoChange = this.handleActivoVinculadoChange.bind(this);
    this.getBackendActivosVinculados = this.getBackendActivosVinculados.bind(this);
    this.getBackendCentrosCostos = this.getBackendCentrosCostos.bind(this);
    this.handleCentroCostosChange = this.handleCentroCostosChange.bind(this);
    this.getBackendTransportadorasPorCentroCostos = this.getBackendTransportadorasPorCentroCostos.bind(this);

    this.formValidation = new FormValidation({
      component: this,
      validators: {
        "formData.tipo_formulario": (value) => Validator.notEmpty(value),
      },
    });
  }
  initForm() {
    this.setState({ loading: true });
    let component = this;

    Promise.all([
      this.state.props.action !== "ADD"
        ? this.ajaxHandler.getJson("/formulario/" + this.state.props.match.params.id)
        : null
    ])
      .then((data) => {
        let formData = data[0];
        let valores_dinamicos = [];
        let movil_atributos_mostrar = [];
        let ticket_atributos_mostrar = [];
        if(this.state.props.action === "ADD"){
          this.state.formData.fecha_inicio = new Date().toISOString();
        }
        if (formData) {
          let key_validator = '';
          if (formData.tipo_formulario.con_movil) {
            key_validator = 'formData.movil';
          }else if(formData.tipo_formulario.con_persona){
            key_validator = 'formData.persona';
          }else if(formData.tipo_formulario.con_ticket){
            key_validator = 'formData.ticket';
          }
          let validator = {};
          validator["formData.tipo_formulario"] = (value) => Validator.notEmpty(value);
          validator[key_validator] = (value) => Validator.notEmpty(value);
          if(key_validator === 'formData.movil' && formData.tipo_formulario.con_chofer) {
            validator["formData.chofer"] = (value) => Validator.notEmpty(value);
          }
          if(key_validator === 'formData.movil' && formData.tipo_formulario.con_transportadora && ConfigBusiness.get('checklist.transportadora.actualizarTransportadora') === 'true') {
            validator["formData.transportadora"] = (value) => Validator.notEmpty(value);
          }
          if(key_validator === 'formData.persona' && formData.tipo_formulario.con_transportadora && ConfigBusiness.get('checklist.transportadora.actualizarTransportadora') === 'true' && ConfigBusiness.get('checklist.transportadora.actualizaTransportadora.actualizarCC') === 'true') {
            validator["formData.centro_costos"] = (value) => Validator.notEmpty(value);
            validator["formData.transportadora"] = (value) => Validator.notEmpty(value);
          }
          this.formValidation = new FormValidation({
            component: this,
            validators: validator,
          });
          if(formData.tipo_formulario.movil_atributos_json && formData.tipo_formulario.con_movil){
            this.setState({ loading: true });
            Promise.all([
              this.ajaxHandler.getJson("/moviles/" + formData.movil.id)
            ])
            .then((data) => {
              component.setState({
                movil: data[0],
              });
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(() => {
              this.setState({ loading: false });
            });
            let movil_atributos_array = JSON.parse(formData.tipo_formulario.movil_atributos_json);
            this.state.movil_atributos.forEach(function(element) {
              if(movil_atributos_array.includes(element.id))
                movil_atributos_mostrar.push(element);
            });
            formData.transportadora = formData.formulario_transportadora
          }
          if(formData.tipo_formulario.ticket_atributos_json && formData.tipo_formulario.con_ticket){
            let ticket_atributos_array = JSON.parse(formData.tipo_formulario.ticket_atributos_json);
            this.state.ticket_atributos.forEach(function(element) {
              if(ticket_atributos_array.includes(element.id))
                ticket_atributos_mostrar.push(element);
            });
          }
          if(formData.tipo_formulario.con_persona && formData.tipo_formulario.con_transportadora){
            formData.transportadora = formData.formulario_transportadora || null;
          }
          valores_dinamicos = castValoresDinamicos(
            formData.tipo_formulario.atributos_dinamicos,
            formData.valores_dinamicos
          );
          component.setState({
            formData: formData,
            valores_dinamicos: valores_dinamicos,
            movil_atributos_mostrar: movil_atributos_mostrar,
            ticket_atributos_mostrar: ticket_atributos_mostrar
          });
        }
        // Security.hasPermission('USUARIO_POSEER_MOVIL')
        let userChofer = JSON.parse(localStorage.getItem("persona"));
        if (Security.hasPermission("USUARIO_POSEER_MOVIL")) {
          let formDataCopy = this.state.formData;
          formDataCopy.chofer = userChofer;
          this.setState({ formData: formDataCopy });
          this.setState({ isChoferValid: false });
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }
  componentWillMount() {
    if(ConfigBusiness.get('moviles.trabajaConDivisiones.habilitado') === 'true'){
      this.state.ticket_atributos.push({
        id: 'division',
        nombre: this.props.intl.formatMessage({
          id: "Division",
          defaultMessage: "División",
        }),
      });
    }
    if(ConfigBusiness.get('moviles.cebe.habilitado') === 'true'){
      this.state.ticket_atributos.push({
        id: 'cebe',
        nombre: this.props.intl.formatMessage({
          id: "Centro_de_beneficios",
          defaultMessage: "Centro de beneficios",
        }),
      });
    }
    this.setState({
      ticket_atributos: this.state.ticket_atributos
    });
    this.ajaxHandler.subscribe(this);
    if ((Security.hasPermission('CHECKLIST_CREAR_HISTORICO') && this.state.props.action === 'ADD') ||
			(Security.hasPermission('CHECKLIST_EDITAR_HISTORICO') && this.state.props.action === 'EDIT') ||
			(Security.hasPermission('CHECKLIST_VISUALIZAR_HISTORICO') && this.state.props.action === 'VIEW')) {
            this.initForm();
            this.getLocation();
		} else {
			this.setState({
				redirectTo: '/error'
			});
        }
  }
  componentWillUnmount() {
    this.ajaxHandler.unsubscribe();
  }

  handleEstadoChange(activo) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["activo"] = activo;
    this.setState({
      formData: formDataCopy,
    });
  }

  handleMovilChange(movil) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["movil"] = movil;
    formDataCopy["activo_vinculado"] = [];
    this.setState({
      formData: formDataCopy,
      entidad: movil,
      movil: movil
    });

    if (movil && this.state.formData.tipo_formulario && this.state.formData.tipo_formulario.con_activo_vinculado) {
      this.setState({ loadingActivosVinculados: true });
      this.ajaxHandler.getJson('/movil-relaciones/activa?movil_id=' + movil.id).then(res => {
        var activos = res && res.como_principal
          ? res.como_principal.map(function(rel) {
              return { id: rel.activo_asociado_id, dominio: rel.movil_asociado && rel.movil_asociado.dominio ? rel.movil_asociado.dominio : rel.activo_asociado_id };
            })
          : [];
        var formDataActual = this.state.formData;
        if (!formDataActual.movil || formDataActual.movil.id !== movil.id) return;
        var copy = JSON.parse(JSON.stringify(formDataActual));
        copy["activo_vinculado"] = activos;
        this.setState({ formData: copy });
      }).finally(() => {
        this.setState({ loadingActivosVinculados: false });
      });
    }
  }

  handlePersonaChange(persona) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["persona"] = persona;
    formDataCopy["centro_costos"] = null;
    formDataCopy["transportadora"] = null;
    this.setState({
      formData: formDataCopy,
      entidad: persona
    });

    var tipoFormulario = this.state.formData.tipo_formulario;
    if (
      persona &&
      tipoFormulario &&
      tipoFormulario.con_persona &&
      tipoFormulario.con_transportadora &&
      ConfigBusiness.get('checklist.transportadora.actualizarTransportadora') === 'true' &&
      ConfigBusiness.get('checklist.transportadora.actualizaTransportadora.actualizarCC') === 'true'
    ) {
      // Guardamos el id de la persona pedida para descartar respuestas
      // obsoletas si el usuario cambia de persona (o sus valores de CC/transportadora)
      // antes de que resuelva el request
      var personaIdPendiente = persona.id;
      this.ajaxHandler.getJson('/personas/' + persona.id).then(personaCompleta => {
        if (!personaCompleta) return;
        var formDataActual = this.state.formData;
        var personaActual = formDataActual && formDataActual.persona;
        if (!personaActual || personaActual.id !== personaIdPendiente) return;
        if (formDataActual.centro_costos || formDataActual.transportadora) return;

        let formDataUpdate = JSON.parse(JSON.stringify(formDataActual));
        formDataUpdate["centro_costos"] = personaCompleta.centroCostos ? personaCompleta.centroCostos : null;
        formDataUpdate["transportadora"] = personaCompleta.transportadora ? personaCompleta.transportadora : null;
        this.setState({ formData: formDataUpdate });
      });
    }
  }

  handleTicketChange(ticket) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["ticket"] = ticket;
    let formulario_ticket_historico = {};
    if(this.state.ticket_atributos_mostrar.length > 0){
      this.state.ticket_atributos_mostrar.map(element => {
        this.setFormularioTicketHistorico(ticket, element.id, formulario_ticket_historico);
      })
      formDataCopy["formulario_ticket_historico"] = formulario_ticket_historico;
    }
    this.setState({
      formData: formDataCopy,
      entidad: ticket
    });
  }

  handleChoferChange(chofer) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["chofer"] = chofer;
    this.setState({
      formData: formDataCopy,
      chofer: chofer,
    });
  }

  handleTransportadoraChange(transportadora) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["transportadora"] = transportadora;
    this.setState({
      formData: formDataCopy
    });
  }

  handleActivoVinculadoChange(activoVinculado) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["activo_vinculado"] = activoVinculado;
    this.setState({ formData: formDataCopy });
  }

  handleCentroCostosChange(centroCostos) {
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    formDataCopy["centro_costos"] = centroCostos;
    // Al cambiar el CC se limpia la transportadora para que el operador elija una
    // del nuevo CC seleccionado
    formDataCopy["transportadora"] = null;
    this.setState({
      formData: formDataCopy
    });
  }

  setFormularioTicketHistorico(ticket, ticketAtributoId, formulario_ticket_historico){
    switch (ticketAtributoId) {
      case "servicio":
        formulario_ticket_historico['servicio_id'] = ticket && ticket.servicio_id ? ticket.servicio_id : null;
        formulario_ticket_historico['servicio_show'] = ticket && ticket.servicio_show ? ticket.servicio_show : null;
        break;
      case "gerenciador":
        formulario_ticket_historico['gerenciador_id'] = ticket && ticket.gerenciador_id ? ticket.gerenciador_id : null;
        formulario_ticket_historico['gerenciador_show'] = ticket && ticket.gerenciador_show ? ticket.gerenciador_show : null;
        break;
      case "centro_costos":
        formulario_ticket_historico['centros_costo_id'] = ticket && ticket.centros_costo_id ? ticket.centros_costo_id : null;
        formulario_ticket_historico['centros_costo_show'] = ticket && ticket.centros_costo_show ? ticket.centros_costo_show : null;
        break;
      case "cebe":
        formulario_ticket_historico['cebe_id'] = ticket && ticket.cebe_id ? ticket.cebe_id : null;
        formulario_ticket_historico['cebe_show'] = ticket && ticket.cebe_show ? ticket.cebe_show : null;
        break;
      case "division":
        formulario_ticket_historico['division_id'] = ticket && ticket.division_id ? ticket.division_id : null;
        formulario_ticket_historico['division_show'] = ticket && ticket.division_show ? ticket.division_show : null;
        break;
      case "factura":
        formulario_ticket_historico['factura_id'] = ticket && ticket.factura_id ? ticket.factura_id : null;
        formulario_ticket_historico['factura_show'] = ticket && ticket.factura_show ? ticket.factura_show : null;
        break;
      default:
        formulario_ticket_historico[ticketAtributoId] = ticket && ticket[ticketAtributoId] ? ticket[ticketAtributoId] : null;
    }
  }

  handleInputFormChange(event) {
		const target = event.target;
		const name = target.name;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy[name] = value;
		this.setState({
			formData: formDataCopy
		});
  }

  handleChangeAtributoDinamico(index, key, value) {
    this.state.valores_dinamicos[index][key] = value;
    // VEC-3451: si la pregunta es "Formulario Asociado" y deja de estar aprobada
    // (el operador pasó de "Sí" a "No"/"No aplica"), se descarta lo respondido
    // en el anidado — no se preserva por si vuelve a poner "Sí".
    if (
      key === 'estado' &&
      parseInt(this.state.valores_dinamicos[index].tipoValor, 10) === Constants.ID_FORMULARIO_ASOCIADO &&
      value !== Constants.ID_ESTADO_APROBACION_VALIDO
    ) {
      delete this.state.valores_dinamicos[index].formulario_asociado;
    }
    this.setState({
      valores_dinamicos: this.state.valores_dinamicos
    });
    let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
    if (this.state.valores_dinamicos[0].observaciones != null) {
      formDataCopy["observaciones"] = this.state.valores_dinamicos[0].observaciones;
      this.setState({
        formData: formDataCopy
      });
    }
    if (this.state.valores_dinamicos[0].adjunto_id != null) {
      formDataCopy["imagenes"] = this.state.valores_dinamicos[0].adjunto_id;
      this.setState({
        formData: formDataCopy
      });
    }
    if (this.state.valores_dinamicos[0].documento_id != null) {
      formDataCopy["documentos"] = this.state.valores_dinamicos[0].documento_id;
      this.setState({
        formData: formDataCopy
      });
    }
	}

	handleTipoFormularioChange(tipo_formulario) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		let valores_dinamicos = [];
		formDataCopy.movil = null;
		formDataCopy.persona = null;
    let movil_atributos_mostrar = [];
    let ticket_atributos_mostrar = [];
		formDataCopy.tipo_formulario = tipo_formulario;
		if (tipo_formulario){
			valores_dinamicos = castValoresDinamicos(tipo_formulario.atributos_dinamicos, this.state.formData.valores_dinamicos);
      if(tipo_formulario.movil_atributos_json && tipo_formulario.con_movil){
        let movil_atributos_array = JSON.parse(tipo_formulario.movil_atributos_json);
        this.state.movil_atributos.forEach(function(element) {
          if(movil_atributos_array.includes(element.id))
            movil_atributos_mostrar.push(element);
        });
      }
      if(tipo_formulario.ticket_atributos_json && tipo_formulario.con_ticket){
        let ticket_atributos_array = JSON.parse(tipo_formulario.ticket_atributos_json);
        this.state.ticket_atributos.forEach(function(element) {
          if(ticket_atributos_array.includes(element.id))
            ticket_atributos_mostrar.push(element);
        });
      }
    }
		let key_validator = '';
    if (tipo_formulario && tipo_formulario.con_movil) {
      key_validator = 'formData.movil';
    }else if(tipo_formulario && tipo_formulario.con_persona){
      key_validator = 'formData.persona';
    }else if(tipo_formulario && tipo_formulario.con_ticket){
      key_validator = 'formData.ticket';
    }
		let validator = {}
		validator['formData.tipo_formulario'] = (value) => Validator.notEmpty(value)
    if(key_validator === 'formData.movil' && tipo_formulario && tipo_formulario.con_chofer){
      validator["formData.chofer"] = (value) => Validator.notEmpty(value);
    }
    if(key_validator === 'formData.movil' && tipo_formulario && tipo_formulario.con_transportadora && ConfigBusiness.get('checklist.transportadora.actualizarTransportadora') === 'true'){
      validator["formData.transportadora"] = (value) => Validator.notEmpty(value);
    }
    if(key_validator === 'formData.persona' && tipo_formulario && tipo_formulario.con_transportadora && ConfigBusiness.get('checklist.transportadora.actualizarTransportadora') === 'true' && ConfigBusiness.get('checklist.transportadora.actualizaTransportadora.actualizarCC') === 'true'){
      validator["formData.centro_costos"] = (value) => Validator.notEmpty(value);
      validator["formData.transportadora"] = (value) => Validator.notEmpty(value);
    }
		validator[key_validator] = (value) => Validator.notEmpty(value)
		this.formValidation = new FormValidation({
			component: this,
			validators: validator
    });
		this.setState({
			formData: formDataCopy,
			valores_dinamicos: valores_dinamicos,
      entidad: null,
      movil_atributos_mostrar: movil_atributos_mostrar,
      ticket_atributos_mostrar: ticket_atributos_mostrar,
      moviles_preloaded: null
		});
	}

	getBackendMoviles (searchTerm) {
    if (searchTerm === '' && this.state.moviles_preloaded !== null) {
      return Promise.resolve({ options: this.state.moviles_preloaded, complete: true });
    }
    let tipoFormulario = this.state.formData.tipo_formulario.movil_estados_disponibles_json ? this.state.formData.tipo_formulario.id : null;
    let searchTipoFormulario = tipoFormulario ? ('&tipoFormulario=' + tipoFormulario) : '';
    let buscarPor = this.state.formData.tipo_formulario.buscar_movil_por === 'unidad' ? '&buscarPor=unidad' : '';
    let sinRestriccionTransportadora = !!(
      this.state.formData.tipo_formulario &&
      this.state.formData.tipo_formulario.con_transportadora &&
      ConfigBusiness.get('checklist.transportadora.actualizarTransportadora') === 'true' &&
      ConfigBusiness.get('checklist.movil.verTodosParaCambioTransportadora') === 'true'
    );
    let sinRestriccionParam = sinRestriccionTransportadora ? '&sinRestriccionTransportadora=true' : '';
		return this.ajaxHandler.getJson('/moviles/simple-search?search=' + searchTerm + searchTipoFormulario + buscarPor + sinRestriccionParam).then(res => {
      if (searchTerm === '') {
        this.setState({ moviles_preloaded: res });
      }
			return {
				options: res,
				complete: true
			}
		});
	}

	getBackendPersonas (searchTerm) {
		let tipoFormulario = ConfigBusiness.get('checklist.respuesta.estadopersonas') === 'true'
			&& this.state.formData.tipo_formulario && this.state.formData.tipo_formulario.persona_estados_disponibles_json
			? this.state.formData.tipo_formulario.id : null;
		let searchTipoFormulario = tipoFormulario ? ('&tipoFormulario=' + tipoFormulario) : '';
		let activeFilter = tipoFormulario ? '' : '&active=1';
		return this.ajaxHandler.getJson('/personas/simple-search?filterNotInternal=true&search=' + searchTerm + '&total=all' + activeFilter + searchTipoFormulario).then(res => {
			return {
				options: res,
				complete: true
			}
		});
	}

  getBackendTipoForms (searchTerm) {
		return this.ajaxHandler.getJson('/tipoformulario/simple-search?search=' + searchTerm).then(res => {
      // Filtra y deja de lado los tipos de formulario que solo pueden ser usados en la APP
      res = res.filter(option => !option.exclusivoApp);
			return {
				options: res,
				complete: true
			}
		});
	}

	getBackendPersonasForBaseOrCc (searchTerm) {
    if (Security.hasPermission('CHECKLIST_RESTRINGIR_VISUALIZACION_CHOFERES')){
      return this.ajaxHandler.getJson('/personas/simple-search/mi-usuario').then(res => {
        return {
          options: Array.isArray(res) ? res : [res],
          complete: true
        }
      });
    } else { 
        if (Security.hasPermission("USUARIO_TRABAJAR_BASES")) {
          return this.ajaxHandler.getJson('/personas/simple-search?active=1&filterNotInternal=true&filterBase=true&search=' + searchTerm + '&total=all').then(res => {
            return {
              options: res,
              complete: true
            }
          });
        }else if (Security.hasPermission("USUARIO_TRABAJAR_CC")) {
          return this.ajaxHandler.getJson('/personas/simple-search?active=1&filterNotInternal=true&centroCosto=true&search=' + searchTerm + '&total=all').then(res => {
            return {
              options: res,
              complete: true
            }
          });
        }else {
          return this.ajaxHandler.getJson('/personas/simple-search?active=1&filterNotInternal=true&search=' + searchTerm + '&total=all').then(res => {
          return {
            options: res,
            complete: true
          }
        });
      }
    }
	}

  getBackendActivosVinculados(searchTerm) {
    return this.ajaxHandler.getJson('/moviles/simple-search/vinculables?search=' + searchTerm).then(res => {
      const movilActualId = this.state.formData.movil ? this.state.formData.movil.id : null;
      const opciones = movilActualId ? res.filter(m => m.id !== movilActualId) : res;
      return { options: opciones, complete: true };
    });
  }

  getBackendTransportadora (searchTerm) {
    if (Security.hasPermission('USUARIO_TRABAJAR_TRANSPORTADORA')) {
      return this.ajaxHandler.getJson('/transportadoras/select').then(res => {
        return {
          options: res,
          complete: true
        }
      });
    } else {
      return this.ajaxHandler.getJson('/transportadoras?nombre=' + searchTerm).then(res => {
        return {
          options: res,
          complete: true
        }
      });
    }
  }

  getBackendCentrosCostos(searchTerm) {
    // GET /centros-costos no aplica filtro por `search` en el backend, así que
    // se descarga la lista una única vez y se filtra client-side para no
    // redescargar todo en cada pulsación del Select.Async
    var filtrar = (opciones) => {
      var term = (searchTerm || '').toLowerCase();
      var filtradas = !term
        ? opciones
        : opciones.filter(function (o) {
            return o && o.nombre && o.nombre.toLowerCase().indexOf(term) !== -1;
          });
      return { options: filtradas, complete: true };
    };

    if (this._centrosCostosCache) {
      return Promise.resolve(filtrar(this._centrosCostosCache));
    }
    if (!this._centrosCostosPromise) {
      this._centrosCostosPromise = this.ajaxHandler.getJson('/centros-costos').then(res => {
        var opciones = Array.isArray(res) ? res : (res && res.data ? res.data : []);
        this._centrosCostosCache = opciones;
        return opciones;
      });
    }
    return this._centrosCostosPromise.then(filtrar);
  }

  getBackendTransportadorasPorCentroCostos() {
    var centroCostos = this.state.formData.centro_costos;
    if (!centroCostos || !centroCostos.id) {
      return Promise.resolve({ options: [], complete: true });
    }
    return this.ajaxHandler.getJson('/transportadoras/centros-costos/' + centroCostos.id).then(res => {
      return {
        options: Array.isArray(res) ? res : [],
        complete: true
      };
    });
  }

  getBackendTickets(searchTerm) {
    const tipoFormulario = this.state.formData.tipo_formulario;
    let estadosParam = '';
    if (tipoFormulario && tipoFormulario.ticket_estados_json) {
      try {
        const estados = JSON.parse(tipoFormulario.ticket_estados_json);
        if (estados && estados.length > 0) {
          estadosParam = '&estados=' + estados.join(',');
        }
      } catch (e) {}
    }
    return this.ajaxHandler.getJson('/tickets/simple-search?&number=10&search=' + searchTerm + estadosParam).then(res => {
      return {
        options: res,
        complete: true,
      };
    });
  }

  ticketTareasModal(event){
    event.persist();

    if(this.state.formData.persona || this.state.formData.ticket){
      this.handleSubmit(event);
    } else {
      this.getTareas().then(() => {
        if (this.props.action === 'ADD' && (this.state.tareas != 0 || this.state.servicios != 0 || this.state.tareasEnResolucion || this.state.serviciosEnResolucion)) {
          $('#ticketTareasModal').modal('toggle');
        } else {
          this.handleSubmit(event);
        }
      });

      event.preventDefault();
    }
  }

	handleSubmit(event) {
    this.setState({ loading: true });
    let component = this
		this.state.formData.tipo_formulario_id = this.state.formData.tipo_formulario.id
		this.state.formData.movil_id = this.state.formData.movil ? this.state.formData.movil.id : null
		this.state.formData.persona_id = this.state.formData.persona ? this.state.formData.persona.id : null
    this.state.formData.ticket_id = this.state.formData.ticket ? this.state.formData.ticket.id : null
		this.state.formData.chofer_id = this.state.formData.chofer ? this.state.formData.chofer.id : null
    this.state.formData.transportadora_id = this.state.formData.transportadora ? this.state.formData.transportadora.id : null
    this.state.formData.activos_asociados_ids = this.state.formData.activo_vinculado
      ? this.state.formData.activo_vinculado.map(function(a) { return a.id; })
      : []
    this.state.formData.centro_costos_id = this.state.formData.centro_costos ? this.state.formData.centro_costos.id : null
		this.state.formData.valores_dinamicos = this.state.valores_dinamicos
		this.state.formData.latitudForm = this.state.latitudForm
		this.state.formData.longitudForm = this.state.longitudForm
		this.state.formData.tareas = this.state.tareas
    let atributoMedidor = this.state.valores_dinamicos.find(atributo => atributo.tipoValor == Constants.ID_MEDIDOR)
    if (this.state.formData.movil_id && atributoMedidor) {
      this.state.formData.medidor = atributoMedidor.value
    }

    if(this.state.props.action === "ADD"){
      this.state.formData.fecha_fin = new Date().toISOString();
    }

    this.ajaxHandler.fetch('/formulario' + (this.props.action === 'ADD' ? '' : '/' + this.state.formData.id), {
      method: this.props.action === 'ADD' ? 'POST' : 'PUT',
      body: JSON.stringify({
        ...this.state.formData
      }),
    })
    .then(response => {
      if(response.status !== 400) {
        component.exit();
      } else {
        response.json().then(data => {
          this.setState({
            errors: data.detalle,
          });
        });
      }
      window.scrollTo(0, 0);
    })
    .catch((error) => {
      component.ajaxHandler.handleError(error);
    })
    .finally(() => {
      this.setState({ loading: false });
    });
  event.preventDefault();
  }

  handleCancel(event) {
    this.exit();
  }

  exit() {
    this.setState({
      redirectTo: "/formulario",
    });
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((event) => this.showPosition(event));
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }

  getTareas(){
    this.setState({ loading: true });
    return new Promise ((resolve, reject) => {
      this.ajaxHandler.getJson('/tareas/movil/'+this.state.formData.movil.id)
      .then(data => {
         this.ajaxHandler.getJson('/tickets/gestoriaAbiertos/movil/'+this.state.formData.movil.id)
        .then(dataServicios => { 
          // Tareas del movil en curso (tickets activos)
          const tareasActivasEnTickets = data.map(tarea => {
            return {tareaId: tarea.id, servicioId: tarea.servicio.id}
          });
          let serviciosActivasEnTickets = dataServicios.map(ticket => ticket.servicio);
          let valoresDinamicos = JSON.parse(JSON.stringify(this.state.valores_dinamicos));
          let tareasDeFallas = [];
          let serviciosDeFallas = [];
          let tareasEnResolucion = false;
          let serviciosEnResolucion = false;

          // Chequeo estado de tareas que generan ticket
          valoresDinamicos.map(valor => {
            if (valor.estado == Constants.ID_ESTADO_APROBACION_INVALIDO) {
              if (valor.genera_ticket) {
                let tareas = valor.tareas;
                tareas.map(tarea => {
                  if (tareasActivasEnTickets.some(t => t.tareaId == tarea.id && valor.servicio_id == t.servicioId)) {
                    tareasEnResolucion = true;
                  } else {
                    tareasDeFallas.push(tarea)
                  }
                })
              } else if (valor.genera_ticket_gestoria) {
                let servicio = valor.servicio_gestoria;
                if (!serviciosActivasEnTickets.includes(servicio.id)) {
                  serviciosDeFallas.push(servicio);
                } else {
                  serviciosEnResolucion = true;
                }
              }
            }
          })
        this.setState({
          // Asigno tareas para el ticket
          tareas: tareasDeFallas,
          servicios: serviciosDeFallas,
          tareasEnResolucion: tareasEnResolucion,
          serviciosEnResolucion: serviciosEnResolucion,
  
        });
      })
      .finally(() => {
        resolve();
      this.setState({ loading: false });
      });
    })
    })
  }

  showPosition(position) {
    this.setState({
      latitudForm: position.coords.latitude,
      longitudForm: position.coords.longitude,
    });
  }

  getMovilAtributo(movilAtributoId){
    if(movilAtributoId === "modelo")
      return this.state.movil.modelo ? this.state.movil.modelo.nombre : '';
    else if (movilAtributoId === 'marca')
      return this.state.movil.modelo ? (this.state.movil.modelo.marca ? this.state.movil.modelo.marca.nombre : '') : '';
    else if (movilAtributoId === 'titular')
      return this.state.movil.titular_eloquent ? this.state.movil.titular_eloquent.nombre : this.state.movil.titular ? this.state.movil.titular.nombre : '';
    else if (movilAtributoId === 'plan_preventivo')
      return this.state.movil.plan_preventivo_eloquent ? this.state.movil.plan_preventivo_eloquent.descripcion : (this.state.movil.planPreventivo ? this.state.movil.planPreventivo.descripcion : '' );
    else if (movilAtributoId === 'centro_costos')
      return this.state.movil.cecos ? this.state.movil.cecos.nombre : (this.state.movil.centroCostos ? this.state.movil.centroCostos.nombre : '');
    else if (movilAtributoId === 'proveedor_gps')
      return this.state.movil.proveedor_gps_eloquent ? this.state.movil.proveedor_gps_eloquent.razon_social : (this.state.movil.proveedorGps ? this.state.movil.proveedorGps.razon_social: '');
    else if (movilAtributoId === 'combustible'){
      return((this.state.movil && this.state.movil.combustible) ? this.state.movil.combustible : (
        this.state.movil &&
        this.state.movil.movilCombustibleTipo &&
        this.state.movil.movilCombustibleTipo.descripcion
      ) ? this.state.movil.movilCombustibleTipo.descripcion : '');     
    }else
      return this.state.movil[movilAtributoId];
  }

  getTicketAtributo(ticket, ticketAtributoId){
    if(ticketAtributoId === "servicio")
      return ticket.servicio_show ? ticket.servicio_show : '';
    else if (ticketAtributoId === 'gerenciador')
      return ticket.gerenciador_show ? ticket.gerenciador_show : '';
    else if (ticketAtributoId === 'centro_costos')
      return ticket.centros_costo_show ? ticket.centros_costo_show : '';
    else if (ticketAtributoId === 'cebe')
      return ticket.cebe_show ? ticket.cebe_show : '' ;
    else if (ticketAtributoId === 'division')
      return ticket.division_show ? ticket.division_show : '';
    else if (ticketAtributoId === 'factura')
      return ticket.factura_show ? ticket.factura_show : '';
    else
      return ticket[ticketAtributoId];
  }

  validarEvidenciaRequeridas(valores_dinamicos){
    if(valores_dinamicos){
      for (let index = 0; index < valores_dinamicos.length; index++) {
        let estadosInformativos = valores_dinamicos[index].estadosInformativos
        if(estadosInformativos && estadosInformativos.find(estado => estado.id == valores_dinamicos[index].estado)){
          if(valores_dinamicos[index].evidencia_observacion_obligatoria && !valores_dinamicos[index].observaciones)
            return false;
          if(valores_dinamicos[index].evidencia_documento_obligatoria){
            if(!valores_dinamicos[index].documento_id || (valores_dinamicos[index].documento_id && valores_dinamicos[index].documento_id.length === 0)){
              return false;
            }
          }
          if(valores_dinamicos[index].evidencia_imagen_obligatoria){
            if(!valores_dinamicos[index].adjunto_id || (valores_dinamicos[index].adjunto_id && valores_dinamicos[index].adjunto_id.length === 0)){
              return false;
            }
          }
        }
      }
    }
    return true;
  }

  formularioAsociadoIncompleto() {
    return this.state.valores_dinamicos.some((valor) =>
      parseInt(valor.tipoValor, 10) === Constants.ID_FORMULARIO_ASOCIADO &&
      valor.estado === Constants.ID_ESTADO_APROBACION_VALIDO &&
      (!valor.formulario_asociado || valor.formulario_asociado.completo === false)
    );
  }

  getGerenciadorNombre() {
  const { formData, props } = this.state;

  if (formData.ticket) {
    if (props.action === 'ADD') {
      return formData.ticket.gerenciador_show;
    } else if (props.action === 'VIEW') {
      return formData.ticket.gerenciador_eloquent.razon_social;
    }
  }
  return '';
}


  render() {
    let state = this.state;
    this.formValidation.validate();
    let formData = this.state.formData;
    let validationState = this.formValidation.state;

    return (
      <React.Fragment>
        {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
        {this.state.loading && <Loading />}
        <div className="row content-body">
          <div className="col-md-12">
            <div className="alert alert-danger" role="alert" hidden={this.state.errors.length === 0}>
              {this.state.errors.map((e, i) => (
                <li key={i}>
                  <FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings["errors.default"])} />
                </li>
              ))}
            </div>
            <form className="form form-horizontal" ref="form" onSubmit={this.ticketTareasModal}>
              <div className="form-body">
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <h4 className="form-section">
                        <i className="icon-home"></i>
                        <FormattedMessage
                          id="formularioAbm.general_data.label_datos_generales"
                          defaultMessage=" Datos Generales "
                        />
                        <div className="float-right" style={{ fontSize: "14px" }}>
                          *{" "}
                          <FormattedMessage
                            id="formularioAbm.general_data.campos_requeridos"
                            defaultMessage="Campos requeridos"
                          />
                        </div>
                      </h4>

                      <div className="row">
                        {/* Tipo Formulario */}
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-md-3 label-control col-form-label" htmlFor="identificador">
                              <FormattedMessage
                                id="formularioAbm.general_data.label_tipo_formulario"
                                defaultMessage="Tipo de Formulario *:"
                              />
                            </label>
                            <div className="col-md-8">
                              <Select.Async
                                name="tipo_formulario"
                                value={this.state.formData.tipo_formulario ? this.state.formData.tipo_formulario : null}
                                valueKey="id"
                                labelKey="nombre"
                                loadOptions={this.getBackendTipoForms}
                                onChange={this.handleTipoFormularioChange}
                                disabled={this.props.action === "VIEW"}
                              />
                            </div>
                            <label className="col-md-1">
                              <i
                                className={
                                  this.state.formData.tipo_formulario
                                    ? this.state.formData.tipo_formulario.icono + " fa-2x"
                                    : ""
                                }
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      {this.state.formData.tipo_formulario && (
                        <div className="row">
                          {/* Descripción */}
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="nombre">
                                <FormattedMessage
                                  id="formularioAbm.general_data.label_descripcion"
                                  defaultMessage="Descripción:"
                                />
                              </label>
                              <div className="col-md-9">
                                <p className="col-form-label">{formData.tipo_formulario.descripcion} </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {this.state.formData.usuario_validacion_id && (
                  <div className="card pull-up">
                    <div className="card-content">
                      <div className="card-body">
                        <h4 className="form-section">
                          <i className="fa fa-thumbs-up "></i> Validación Manual
                        </h4>
                        <div className="row">
                          {/* Tipo Formulario */}
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="identificador">
                                Usuario:
                              </label>
                              <div className="col-md-9">
                                <p className="col-form-label">{this.state.formData.usuario_validacion.label}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          {/* Tipo Formulario */}
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label" htmlFor="identificador">
                                Fecha:
                              </label>
                              <div className="col-md-9">
                                <p className="col-form-label">{this.state.formData.validated_at}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group row">
                              <label className="col-md-3 label-control col-form-label">
                                Comentario:
                              </label>
                              <div className="col-md-9">
                                <p className="col-form-label">{this.state.formData.comentario}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {this.state.formData.tipo_formulario && (
                  <div className="card pull-up">
                    <div className="card-content">
                      <div className="card-body">
                        <h4 className="form-section">
                          <i className="fa fa-file-text-o"></i>
                          <FormattedMessage
                            id="formularioAbm.form_to_complete.label_formulario_completar"
                            defaultMessage=" Formulario a Completar "
                          />
                          <div className="float-right" style={{ fontSize: "14px" }}>
                            *{" "}
                            <FormattedMessage
                              id="formularioAbm.form_to_complete.campos requeridos"
                              defaultMessage="campos requeridos"
                            />
                          </div>
                        </h4>
                        {this.state.formData.tipo_formulario.con_persona ? (
                          <div className="row">
                            {/* Persona */}
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-md-3 label-control col-form-label" htmlFor="movil">
                                  <FormattedMessage
                                    id="formularioAbm.form_to_complete.label_persona"
                                    defaultMessage="Persona *:"
                                  />
                                </label>
                                <div className="col-md-9">
                                  <Select.Async
                                    key={this.state.formData.tipo_formulario ? this.state.formData.tipo_formulario.id : 'none'}
                                    name="storageTypeId"
                                    value={this.state.formData.persona}
                                    valueKey="id"
                                    labelKey="label"
                                    loadOptions={this.getBackendPersonas}
                                    onChange={this.handlePersonaChange}
                                    disabled={this.props.action === "VIEW"}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.formData.tipo_formulario.con_persona && this.state.formData.tipo_formulario.con_transportadora && ConfigBusiness.get('checklist.transportadora.actualizarTransportadora') === 'true' && ConfigBusiness.get('checklist.transportadora.actualizaTransportadora.actualizarCC') === 'true' ? (
                          <div>
                            <div className="row">
                              {/* Centro de Costos */}
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-md-3 label-control col-form-label">
                                    <FormattedMessage
                                      id="formularioAbm.form_to_complete.label_centro_costos"
                                      defaultMessage="Centro de Costos *:"
                                    />
                                  </label>
                                  <div className="col-md-9">
                                    <Select.Async
                                      name="centro_costos"
                                      value={this.state.formData.centro_costos}
                                      valueKey="id"
                                      labelKey="nombre"
                                      loadOptions={this.getBackendCentrosCostos}
                                      onChange={this.handleCentroCostosChange}
                                      disabled={this.props.action === "VIEW" || !this.state.formData.persona}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              {/* Transportadora filtrada por CC */}
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-md-3 label-control col-form-label">
                                    <FormattedMessage
                                      id="formularioAbm.form_to_complete.label_transportadora_persona"
                                      defaultMessage="Transportadora *:"
                                    />
                                  </label>
                                  <div className="col-md-9">
                                    <Select.Async
                                      key={this.state.formData.centro_costos ? this.state.formData.centro_costos.id : 'sin-cc'}
                                      name="transportadora"
                                      value={this.state.formData.transportadora}
                                      valueKey="id"
                                      labelKey="nombre"
                                      loadOptions={this.getBackendTransportadorasPorCentroCostos}
                                      onChange={this.handleTransportadoraChange}
                                      disabled={this.props.action === "VIEW" || !this.state.formData.centro_costos}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.formData.tipo_formulario.con_movil ? (
                          <div className="row">
                            {/* Movil */}
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-md-3 label-control col-form-label" htmlFor="movil">
                                  <FormattedMessage
                                    id="formularioAbm.form_to_complete.label_movil"
                                    defaultMessage="Móvil *:"
                                  />
                                </label>
                                <div className="col-md-9">
                                  <Select.Async
                                    key={this.state.formData.tipo_formulario ? this.state.formData.tipo_formulario.id : 'none'}
                                    name="storageTypeId"
                                    value={this.state.formData.movil}
                                    valueKey="id"
                                    labelKey={this.state.formData.tipo_formulario && this.state.formData.tipo_formulario.buscar_movil_por === 'unidad' ? 'unidad' : 'dominio'}
                                    autoload={this.props.action !== "VIEW"}
                                    loadOptions={this.getBackendMoviles}
                                    onChange={this.handleMovilChange}
                                    disabled={this.props.action === "VIEW"}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.movil && this.state.movil_atributos_mostrar.map((element, index) => {
                              return (
                                <div key={index} className="col-md-6">
                                  <div className="form-group row">
                                    <label className="col-md-3 label-control col-form-label" htmlFor="movil">
                                      {element.nombre} :
                                    </label>
                                    <div className="col-md-9">
                                      <div className="form-control-static col-form-label form-value">
                                        {this.getMovilAtributo(element.id)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                );
                              })
                            }
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.formData.tipo_formulario.con_ticket ? (
                          <div className="row">
                            {/* TICKET */}
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-md-3 label-control col-form-label" htmlFor="movil">
                                  <FormattedMessage
                                    id="Ticket"
                                    defaultMessage="Ticket"
                                  /> *:
                                </label>
                                <div className="col-md-8">
                                  <Select.Async
                                    name="storageTypeId"
                                    value={this.state.formData.ticket}
                                    valueKey="id"
                                    labelKey="id"
                                    loadOptions={this.getBackendTickets}
                                    onChange={this.handleTicketChange}
                                    disabled={this.props.action === "VIEW"}
                                  />
                                </div>
                                {this.state.formData.ticket ? (
                                  <div className="col-md-1 d-flex align-items-center">
                                    <a
                                      href={'/tickets/' + this.state.formData.ticket.id + '/edit'}
                                      className="btn btn-float-sm btn-round btn-fleet ml-1"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      title="Ver ticket"
                                    >
                                      <i className="la la-search align-middle"></i>
                                    </a>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.formData.tipo_formulario.con_ticket ? (
                          <>
                            <div className="row">
                              {/* VEHICULO */}
                              <div className="col-md-6">
                                <div className="form-group row">
                                  <label className="col-md-3 label-control col-form-label" htmlFor="movil">
                                    <FormattedMessage
                                      id="Vehiculo"
                                      defaultMessage="Vehículo"
                                    /> :
                                  </label>
                                  <div className="col-md-9">
                                    <div className="form-control-static col-form-label form-value">
                                      {this.state.formData.ticket ? this.state.formData.ticket.dominio : ''}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            <div className="row">
                              {this.state.formData.ticket && this.state.ticket_atributos_mostrar.map((element, index) => {
                                return (
                                  <div key={index} className="col-md-6">
                                    <div className="form-group row">
                                      <label className="col-md-3 label-control col-form-label" htmlFor="movil">
                                        {element.nombre} :
                                      </label>
                                      <div className="col-md-9">
                                        <div className="form-control-static col-form-label form-value">
                                          {
                                            this.state.formData.formulario_ticket_historico ? 
                                              this.getTicketAtributo(this.state.formData.formulario_ticket_historico , element.id) 
                                              : ''
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  );
                                })
                              }
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        {this.state.formData.tipo_formulario.con_chofer ? (
                          <div className="row">
                            {/* Chofer */}
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-md-3 label-control col-form-label">
                                  <FormattedMessage id="formularioAbm.actualizar_chofer" defaultMessage="Actualizar Chofer" /> *:
                                </label>
                                <div className="col-md-9">
                                  <Select.Async
                                    name="storageTypeId"
                                    value={this.state.formData.chofer}
                                    valueKey="id"
                                    labelKey="label"
                                    loadOptions={this.getBackendPersonasForBaseOrCc}
                                    onChange={this.handleChoferChange}
                                    disabled={this.props.action === "VIEW" || !this.state.isChoferValid}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.formData.tipo_formulario.con_transportadora && !this.state.formData.tipo_formulario.con_persona && ConfigBusiness.get('checklist.transportadora.actualizarTransportadora') === 'true' ? (
                          <div className="row">
                            {/* Transportadora — flujo con_movil */}
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-md-3 label-control col-form-label">
                                  <FormattedMessage id="formularioAbm.actualizar_transportadora" defaultMessage="Actualizar Transportadora" /> *:
                                </label>
                                <div className="col-md-9">
                                  <Select.Async
                                    name="transportadora"
                                    value={this.state.formData.transportadora}
                                    valueKey="id"
                                    labelKey="nombre"
                                    loadOptions={this.getBackendTransportadora}
                                    onChange={this.handleTransportadoraChange}
                                    disabled={this.props.action === "VIEW" || !this.state.isChoferValid}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.formData.tipo_formulario.con_activo_vinculado ? (
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group row">
                                <label className="col-md-3 label-control col-form-label">
                                  <FormattedMessage id="formularioAbm.activo_vinculado" defaultMessage="Activo vinculado" />
:
                                </label>
                                <div className="col-md-9">
                                  {this.state.loadingActivosVinculados ? (
                                    <Select
                                      isLoading={true}
                                      disabled={true}
                                      multi={true}
                                      value={[]}
                                      placeholder={this.props.intl.formatMessage({ id: 'formularioAbm.activo_vinculado.placeholder', defaultMessage: 'Seleccionar activos asociados' })}
                                      options={[]}
                                    />
                                  ) : (
                                    <Select.Async
                                      name="activo_vinculado"
                                      multi={true}
                                      placeholder={this.props.intl.formatMessage({ id: 'formularioAbm.activo_vinculado.placeholder', defaultMessage: 'Seleccionar activos asociados' })}
                                      value={this.state.formData.activo_vinculado}
                                      valueKey="id"
                                      labelKey="dominio"
                                      loadOptions={this.getBackendActivosVinculados}
                                      onChange={this.handleActivoVinculadoChange}
                                      disabled={this.props.action === "VIEW" || !this.state.formData.movil}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.valores_dinamicos.map(
                          (atributoDinamico, index) => {
                            if (!atributoDinamico || !atributoDinamico.activo) return null
                            if (parseInt(atributoDinamico.tipoValor, 10) === Constants.ID_ERIC_IA) {
                              return (this.props.action === 'VIEW' || this.props.action === 'EDIT') ? (
                                <EricInspeccionPanel key={index} formularioId={parseInt(this.state.props.match.params.id, 10)} />
                              ) : null
                            }
                            return (
                              <div className="row" key={index}>
                                <div className="col-md-6">
                                  <div className="form-group row">
                                    <AtributoDinamicoInstancia
                                      movil={formData.movil}
                                      ocultarInput={this.props.action === "VIEW"}
                                      disabled={this.props.action === "VIEW" || this.state.entidad == null}
                                      handleChange={(name, value) =>
                                        this.handleChangeAtributoDinamico(index, name, value)
                                      }
                                      atributo={atributoDinamico}
                                    />
                                  </div>
                                </div>
                              </div>
                            )
                          }
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {this.state.valores_dinamicos.map((atributoDinamico, index) => {
                  if (!atributoDinamico || !atributoDinamico.activo) return null;
                  if (parseInt(atributoDinamico.tipoValor, 10) !== Constants.ID_FORMULARIO_ASOCIADO) return null;
                  if (atributoDinamico.estado !== Constants.ID_ESTADO_APROBACION_VALIDO) return null;
                  // VEC-3451: si este formulario ya existe (EDIT/VIEW) y ya tiene un
                  // formulario asociado guardado para esta pregunta, se lo pasamos para
                  // que el bloque cargue las respuestas existentes en vez de arrancar en blanco.
                  const asociadoExistente = (this.state.formData.formularios_asociados || []).find(
                    (asociado) => asociado.atributo_dinamico_origen_id === atributoDinamico.atributo_dinamico_id
                  );
                  return (
                    <FormularioAsociadoBloque
                      key={'formulario-asociado-' + index}
                      tipoFormularioAsociadoId={atributoDinamico.tipo_formulario_asociado_id}
                      asociadoExistente={asociadoExistente}
                      // El asociado solo se completa al crear (ADD). En VIEW/EDIT queda
                      // siempre de solo lectura — el PUT no persiste cambios sobre
                      // formulario_asociado, así que no se puede depender de la
                      // deshabilitación por this.state.entidad == null (bug de EDIT, sin
                      // arreglar) para lograr esto: tiene que ser explícito.
                      disabled={this.props.action === "VIEW" || this.props.action === "EDIT"}
                      onChange={(payload) => this.handleChangeAtributoDinamico(index, 'formulario_asociado', payload)}
                    />
                  );
                })}
                <div className="card pull-up">
                  <div className="card-content">
                    <div className="card-body">
                      <div className="text-cd text-right">
                        {this.props.action !== "VIEW" && (
                          <>
                            <button
                              type="submit"
                              className="btn btn-primary mr-1"
                              disabled={
                                !validationState.form.valid ||
                                atributosDinamicosRequeridosFaltantes(this.state.valores_dinamicos) ||
                                !this.validarEvidenciaRequeridas(this.state.valores_dinamicos) ||
                                this.formularioAsociadoIncompleto()
                              }
                            >
                              <i className="fa fa-check-circle"></i>
                              <FormattedMessage id="formularioAbm.finish_button.guardar" defaultMessage=" Guardar" />
                            </button>
                          </>
                        )}
                        <button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
                          <i className="fa fa-times-circle"></i>{" "}
                          {this.props.action === "VIEW"
                            ? this.props.intl.formatMessage({
                                id: "formularioAbm.finish_button.volver",
                                defaultMessage: "Volver",
                              })
                            : this.props.intl.formatMessage({
                                id: "formularioAbm.finish_button.cancelar",
                                defaultMessage: "Cancelar",
                              })}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="modal fade" tabIndex="-1" id="ticketTareasModal" role="dialog" aria-labelledby="ticketTareasModalLable">
          <div className="modal-lg modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header bg-fleet">
                <h4 className="modal-title text-white" id="ticketTareasModalTitle">
                  <FormattedMessage id="FormularioAbm.ticket_modal.title" defaultMessage="Ticket"/>
                </h4>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-body modal-grey modal-mh ovf-x-hidden">
                <div className="container-fluid">
                  {(this.state.tareas != 0) ? (
                    <div>
                      {<FormularioTicketTareas tareas={this.state.tareas}></FormularioTicketTareas>}
                    </div>
                  ) : ''}
                  {(this.state.servicios != 0 && ConfigBusiness.get('mantenimientos.gestoria.habilitado') === 'true') ? (
                    <div>
                      <div className="card pull-up form-body">
                        <div className="card-content">
                          <div className="card-body">
                            <h4 className="form-section">
                              <FormattedMessage id="FormularioTicketTareas.render.modal.header_gestoria" defaultMessage="Se van a generar tickets de gestoría con los siguientes servicios"/>
                            </h4>
                            <div className="row">
                              <div className="col-md-12">
                                <table className="table">
                                  <thead className="thead-fleet">
                                    <tr>
                                      <th scope="col"><FormattedMessage id="FormularioTicketTareas.render.modal.table_column_servicios" defaultMessage="Servicios"/></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                  {this.state.servicios.map((servicio, index)=>{
                                    return(
                                      <tr key={index}>
                                        <td className="align-middle">{servicio.nombre}</td>
                                      </tr>
                                    );
                                  })}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : ''}
                  {this.state.tareasEnResolucion == true || this.state.serviciosEnResolucion == true ?
                    <div className="form-horizontal" id="tareasFallidasEnCurso">
                      <div className="card-content card">
                          <div className="card-body">
                          <div className="text-cd text-center">
                            <FormattedMessage id="FormularioAbm.ticket_tareas_modal.task_not_included" defaultMessage="Hay fallas encontradas que no generan tickets o ya tienen un ticket creado"/>
                          </div>
                          </div>
                      </div>
                    </div>
                  : ''}
                </div>

              </div>
              <div className="modal-footer modal-grey">
                  <button type="button" className="btn btn-primary mr-1" data-dismiss="modal" onClick={this.handleSubmit} ><FormattedMessage id="FormularioAbm.ticket_tareas_modal.button_ok" defaultMessage="Ok"/></button>
                  <button type="button" className="btn btn-danger" data-dismiss="modal" ><FormattedMessage id="FormularioAbm.ticket_tareas_modal.button_cancel" defaultMessage="Cancel"/></button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default injectIntl(FormularioAbm);
